import { Box, Text } from '@chakra-ui/react';
import { slotFor } from '@/lib/slot-color';

interface Props {
  block: {
    type: number;
    label: string;
    options: Map<string, string>;
  };
  content: string[];
  hideLabel?: boolean;
}

export default function SelectionBlock({ block, content, hideLabel = false }: Props) {
  const values = Array.isArray(content)
    ? content.map((item) => block.options.get(item) ?? item)
    : [];

  if (values.length === 0) return null;

  // DS rule: tag color groups BY FIELD LABEL, never by index or meaning.
  const slot = slotFor(block.label || 'field');
  const display = values.join(', ');

  return (
    <Box
      display='inline-flex'
      alignItems='center'
      gap={2}
      px={3}
      py={1}
      borderRadius='full'
      bg={`slot${slot}.bg`}
      borderWidth='1px'
      borderColor='border'
      lineHeight={1.2}
    >
      {!hideLabel && (
        <Text
          fontSize='label'
          textTransform='uppercase'
          letterSpacing='wider'
          color={`slot${slot}.fg`}
          fontWeight='semibold'
        >
          {block.label}
        </Text>
      )}
      <Text fontSize='xs' fontWeight='semibold' color='fg.strong'>
        {display}
      </Text>
    </Box>
  );
}
